import { createAction, props } from "@ngrx/store";
import { Alert } from "../../models/alert.model";

export const alertRecieved = createAction(
  "[API] Alert Recieved",
  props<Alert>()
);
